import './styles/header.css'

export default props => {
    return (
        <header><h1>Meu IP-v4</h1></header>
    )
}